import React from "react";
import "../styles/terms.css";

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Service Agreement for Fleet Tracking Services</h1>

      <p>
        This Service Agreement ("Agreement") is entered into on <strong>[Insert Date]</strong> ("Effective Date") between:
      </p>

      <p>
        <strong>TrackSmart Solutions</strong> ("Company"), a fleet tracking service provider registered under the laws of Nigeria, with its principal office at <strong>[Insert Company Address]</strong>, and <strong>[Customer Name]</strong> ("Customer"), a business entity with its principal office at <strong>[Insert Customer Address]</strong>. Collectively referred to as the "Parties."
      </p>

      <h2>1. Definitions</h2>
      <p><strong>Services:</strong> The fleet tracking software and related services...</p>
      <p><strong>Subscription Plan:</strong> The tiered service plan (Basic, Standard, or Premium)...</p>
      <p><strong>Tracking Device:</strong> The GPS tracking hardware...</p>
      <p><strong>Vehicle:</strong> Any asset enrolled in the Services.</p>
      <p><strong>Subscription Term:</strong> Minimum 3 months.</p>
      <p><strong>Installation Fee:</strong> Fee for labor only.</p>
      <p><strong>Default:</strong> Failure to pay or comply.</p>

      <h2>2. Services</h2>
      <p>2.1 The Company shall provide tracking services as per selected plan.</p>
      <p>2.2 Devices remain Company property.</p>
      <p>2.3 Changes may be made with 30-day notice.</p>

      <h2>3. Subscription Plans and Fees</h2>

      <p><strong>3.1 Subscription Fees:</strong></p>
      <ul>
        <li>Basic: ₦7,500/month</li>
        <li>Standard: ₦12,000/month</li>
        <li>Premium: ₦18,000/month</li>
      </ul>

      <p><strong>3.2 Installation:</strong></p>
      <ul>
        <li>Motorcycles: ₦3,000</li>
        <li>Cars: ₦7,000</li>
        <li>Trucks: ₦10,000</li>
      </ul>

      <p><strong>3.3 Discounts:</strong></p>
      <ul>
        <li>3 months – 5%</li>
        <li>6 months – 10%</li>
        <li>12 months – 15% + free installation</li>
      </ul>

      <p><strong>3.4</strong> Payment is due on the 1st of each cycle. Late payment constitutes a default.</p>

      <h2>4. Tracking Device Ownership</h2>
      <p>4.1 Devices remain our property. No tampering allowed.</p>
      <p>4.2 Free uninstallation after cancellation unless tampered.</p>
      <p>4.3 Non-compliance for uninstallation or misplaced device = ₦40,000 penalty/device.</p>

      <h2>5. Customer Obligations</h2>
      <ul>
        <li>Pay all due fees on time.</li>
        <li>Ensure access to vehicles.</li>
        <li>No illegal use or tampering.</li>
      </ul>

      <h2>6. Referral Program</h2>
      <ul>
        <li>₦2,000 per valid referral</li>
        <li>Bonus after 1st payment</li>
        <li>Max 10 referrals/month</li>
        <li>Extra ₦5,000 after 5 referrals</li>
      </ul>

      <h2>7. Default & Termination</h2>
      <p>Late fees, service suspension, and device disablement after 16 days of non-payment.</p>
      <p>Termination by either party possible with notice.</p>

      <h2>8. Confidentiality</h2>
      <p>All data shared is confidential unless required by law.</p>

      <h2>9. Limitation of Liability</h2>
      <p>We're not liable for indirect or incidental damages.</p>

      <h2>10. Force Majeure</h2>
      <p>No party liable for things outside our control (e.g. flood, government policy).</p>

      <h2>11. Governing Law & Dispute Resolution</h2>
      <p>Laws of Nigeria apply. Disputes go to arbitration in Lagos.</p>

      <h2>12. Miscellaneous</h2>
      <ul>
        <li>This is the full agreement.</li>
        <li>Changes must be written.</li>
        <li>Notices via Email/WhatsApp/Courier.</li>
      </ul>
    </div>
  );
};

export default Terms;
